import emailValidator from 'email-validator';

export default function isEmail(email) {
    return emailValidator.validate(email);
}



/** WEBPACK FOOTER **
 ** ./src/utils/isEmail.js
 **/